require.config({
    waitSeconds: 200,

    paths: {
        jquery: 'vendor/jquery/jquery-3.5.1.min',
        gsap: 'vendor/gsap/minified/gsap.min',
        scrollTo: 'vendor/gsap/minified/ScrollToPlugin.min',
        iScroll: 'vendor/iscroll/iscroll-probe-5.2.0.min'
    },

    shim: {
        scrollTo: {
            deps: ['gsap']
        }
    }
});

require(
    [
        'application',
        'jquery',
        'gsap',
        'scrollTo',
        'iScroll'
    ],
    function(app, $, gsapModule, scrollToModule) {
        'use strict';

        /*
         * Die vorhandenen Module greifen teilweise noch auf window.gsap zu.
         * Die UMD-Builds liefern unter RequireJS dagegen Modulobjekte zurück.
         */
        const oGsap = gsapModule
            && (gsapModule.gsap || gsapModule.default || gsapModule);
        const oScrollToPlugin = scrollToModule
            && (
                scrollToModule.ScrollToPlugin
                || scrollToModule.default
                || scrollToModule
            );

        if (oGsap) {
            window.gsap = oGsap;
        }

        if (
            oGsap
            && oScrollToPlugin
            && 'function' === typeof oGsap.registerPlugin
        ) {
            oGsap.registerPlugin(oScrollToPlugin);
        }

        $(function() {
            new app.Application();
        });
    }
);

define("main", function(){});

